import { render, staticRenderFns } from "./fulfillment-detail.vue?vue&type=template&id=450b746c"
import script from "./fulfillment-detail.vue?vue&type=script&lang=js"
export * from "./fulfillment-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports